import React from 'react'
import Paper from '@mui/material/Paper'
import SvgIcon from '@mui/material/SvgIcon'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

const InfoPaper = ({
  infoText,
  color,
  showButton,
  buttonText,
  buttonAction,
}: {
  infoText: string
  color?: 'blue' | 'red'
  showButton?: boolean
  buttonText?: string
  buttonAction?: () => void
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        background: color === 'red' ? 'rgba(211, 47, 47, 0.15)' : 'rgba(42, 234, 250, 0.15)',
        color: '#fff',
        padding: '18px 10px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '15px',
        width: '100%',
        boxSizing: 'border-box',
        borderRadius: '8px',
      }}>
      <SvgIcon
        component={InfoOutlinedIcon}
        sx={{
          color: color === 'red' ? 'rgba(211, 47, 47, 1)' : 'rgba(42, 234, 250, 1)',
        }}
      />
      <Typography
        variant="body1"
        sx={{
          fontWeight: '500',
          color: color === 'red' ? 'rgba(211, 47, 47, 1)' : 'rgba(42, 234, 250, 1)',
          fontFamily: 'Space Grotesk, sans-serif',
        }}>
        {infoText}
      </Typography>
      {showButton ? (
        <Button
          variant="contained"
          color="success"
          onClick={buttonAction}
          sx={{
            fontWeight: '600',
            color: '#181D38',
            background: '#2AEAFA',
            fontFamily: 'Space Grotesk, sans-serif',

            '&.Mui-disabled': {
              color: 'rgba(255, 255, 255, 0.5)',
              background: 'rgba(255, 255, 255, 0.15)',
            },
            '&:hover': {
              background: 'rgba(255, 255, 255, 0.8)',
            },
          }}>
          {buttonText}
        </Button>
      ) : null}
    </Paper>
  )
}

export default InfoPaper
